<template>
    <div class="application">
        <div class="title">
            <p>数据分析</p>
        </div>
        <el-card class="main">
            <div class="subTitle">
                <p>商品分析</p>
            </div>
            <div class="list" v-if="marketing_open && marketing.length > 0">
                <el-row :gutter="40">
                    <el-col :span="6" class="item" v-for="(item, index) in marketing" :key="index" v-show="item.status != 2">
                        <div class="ibox" :style="`background:url(${item.background})`" @click="routeTo(item)" v-show="item.status != 2">
                            <div class="img">
                                <el-image :src="item.img"></el-image>
                            </div>
                            <div class="text">
                                <p>{{ item.name }}</p>
                                <span>{{ item.sub_title }}</span>
                            </div>
                        </div>
                        <div class="price">
                            <p v-if="item.is_free == 1" class="isPay">已获得 <i class="iconfont icon-kongxinduigou oColor"></i></p>
                            <p v-else-if="item.merchant_status == 1" class="isPay">已购买 <i class="iconfont icon-kongxinduigou oColor"></i></p>
                            <!-- <p v-else @click="showPay(item)">
                                ￥{{ item.amount }}
                                <i class="iconfont icon-gouwuche"></i>
                            </p> -->
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-empty description="暂无应用！" v-else></el-empty>
        </el-card>
        <el-card class="main">
            <div class="subTitle">
                <p>物流分析</p>
                <!-- <span>多种工具助力营销</span> -->
            </div>
            <div class="list" v-if="coupon_open && coupon.length > 0">
                <el-row :gutter="40">
                    <el-col :span="6" class="item" v-for="(item, index) in coupon" :key="index" v-show="item.status != 2">
                        <div class="ibox" :style="`background:url(${item.background})`" @click="routeTo(item)" v-show="item.status != 2">
                            <div class="img">
                                <el-image :src="item.img"></el-image>
                            </div>
                            <div class="text">
                                <p>{{ item.name }}</p>
                                <span>{{ item.sub_title }}</span>
                            </div>
                        </div>
                        <div class="price">
                            <p v-if="item.is_free == 1" class="isPay">已获得 <i class="iconfont icon-kongxinduigou oColor"></i></p>
                            <p v-else-if="item.merchant_status == 1" class="isPay">已购买 <i class="iconfont icon-kongxinduigou oColor"></i></p>
                            <!-- <p v-else @click="showPay(item)">
                                ￥{{ item.amount }}
                                <i class="iconfont icon-gouwuche"></i>
                            </p> -->
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-empty description="暂无应用！" v-else></el-empty>
        </el-card>
        <Pay ref="refPay" :id="id" :item="item" :price="price" @init="getApplicationFunc"></Pay>
    </div>
</template>

<script>
import Pay from "@/components/Modules/Application/Pay.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
    data() {
        return {
            marketing: [],
            coupon: [],
            marketing_open: false,
            coupon_open: false,
            id: 0,
            price: 0,
            item: { amount: "" },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    components: {
        Pay,
    },
    mounted() {
        this.getApplicationFunc();
    },
    methods: {
        ...mapMutations({
            setAppVerify: "setAppVerify",
        }),
        ...mapActions({
            adminApplication: "activity/adminApplication",
        }),
        getApplicationFunc() {
            this.marketing = [];
            this.coupon = [];
            this.marketing_open = false;
            this.coupon_open = false;
            this.adminApplication({ token: this.getToken }).then(({ data }) => {
                if (data.code == 1) {
                    this.setAppVerify(data.data.list);
                    let arr ={
                            application_category_id: "0",
                            code: "ACTIVITY_LINK",
                            id: 3,
                            is_free: "0",
                            merchant_status: 0,
                            name: "商品销售",
                            status: "1",
                            sub_title: "查看门店商品销售情况",
                            img:require("@/assets/img/application/img_fx.png"),
                            background:require("@/assets/img/application/fx.png")
                    }
                    this.marketing_open = true;
                    this.marketing.push(arr);
                  //  data.data.list.forEach((item) => {
                  //       switch (item.code) {
                  //           case "ACTIVITY_TEAM":
                  //               item.img = require("@/assets/img/application/img_pt.png");
                  //               item.background = require("@/assets/img/application/pt.png");
                  //               break;
                  //           case "ACTIVITY_SHARE":
                  //               item.img = require("@/assets/img/application/img_fx.png");
                  //               item.background = require("@/assets/img/application/fx.png");
                  //               break;
                  //           case "ACTIVITY_LINK":
                  //               item.img = require("@/assets/img/application/img_jl.png");
                  //               item.background = require("@/assets/img/application/jl.png");
                  //               break;
                  //           case "ACTIVITY_POSTER":
                  //               item.img = require("@/assets/img/application/img_hb.png");
                  //               item.background = require("@/assets/img/application/hb.png");
                  //               break;
                  //           default:
                  //               break;
                  //       }
                  //       if (item.code == "ACTIVITY_TEAM" || item.code == "ACTIVITY_SHARE" || item.code == "ACTIVITY_LINK" || item.code == "ACTIVITY_POSTER") {
                  //           this.marketing.push(item);
                  //           if (item.status == 1) {
                  //               this.marketing_open = true;
                  //           }
                  //       }
                  //   });
                  let brr =[{
                            application_category_id: "0",
                            code: "QRCODE",
                            id: 3,
                            is_free: "0",
                            merchant_status: 0,
                            name: "物流公司占比",
                            status: "1",
                            sub_title: "查看门店物流公司发货占比数",
                            img:require("@/assets/img/application/img_jl.png"),
                            background:require("@/assets/img/application/jl.png")
                    },
                    {
                            application_category_id: "0",
                            code: "ACTIVI_LINK",
                            id: 3,
                            is_free: "0",
                            merchant_status: 0,
                            name: "发货统计",
                            status: "1",
                            sub_title: "物流公司发货总价和单价统计",
                            img:require("@/assets/img/application/img_hb.png"),
                            background:require("@/assets/img/application/hb.png")
                    }]
                    this.coupon_open = true;
                    this.coupon=brr;
                    // data.data.list.forEach((item) => {
                    //     switch (item.code) {
                    //         case "COUPONS":
                    //             item.img = require("@/assets/img/application/img_yhj.png");
                    //             item.background = require("@/assets/img/application/yhj.png");
                    //             break;
                    //         case "QRCODE":
                    //             item.img = require("@/assets/img/application/img_hb.png");
                    //             item.background = require("@/assets/img/application/hb.png");
                    //             break;
                    //         case "WEAL_PRESENT_CARD":
                    //             item.img = require("@/assets/img/application/img_jl.png");
                    //             item.background = require("@/assets/img/application/jl.png");
                    //             break;
                    //         default:
                    //             break;
                    //     }
                    //     if (item.code == "COUPONS" || item.code == "QRCODE" || item.code == "WEAL_PRESENT_CARD") {
                    //         this.coupon.push(item);
                    //         if (item.status != 2) {
                    //             this.coupon_open = true;
                    //         }
                    //     }
                    // });
                }
            });
        },
        routeTo(item) {
            this.item = item;
            // if (item.amount.length != 0) {
            //     if (item.is_free != 1 && item.merchant_status != 1) {
            //         this.showPay(item);
            //         return;
            //     }
            // }
            switch (item.code) {
                case "ACTIVITY_LINK":
                    this.$router.push({ path: "/home/MerchanDising?type=activity_team" });
                    break;
                case "QRCODE":
                    this.$router.push({ path: "/home/CompanyProportion?type=activity_share" });
                    break;
                case "ACTIVI_LINK":
                    this.$router.push({ path: "/home/ShippingStatistics?type=activity_link" });
                    break;
                // case "ACTIVITY_POSTER":
                //     this.$router.push({ path: "/home/activity" });
                //     break;
                // case "COUPONS":
                //     this.$router.push({ path: "/home/coupon" });
                //     break;
                // case "QRCODE":
                //     this.$router.push({ path: "/home/erweimaactive" });
                //     break;
                // case "WEAL_PRESENT_CARD":
                //     this.$router.push({ path: "/home/cardManage" });
                //     break;
                default:
                    break;
            }
        },
        showPay(item) {
            if (Number(item.amount) == 0) {
                this.routeTo(item);
                return;
            }
            this.id = item.id;
            this.$refs.refPay.dialogVisible = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.application {
    min-width: 1260px;
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .el-card.main {
        margin: 24px;
        border-radius: 0;
        padding: 24px 24px 40px;
        .subTitle {
            margin-bottom: 48px;
            p {
                display: inline-block;
                font-size: 18px;
                color: #333;
                margin-right: 10px;
                padding-left: 12px;
                position: relative;
                &::before {
                    content: "";
                    width: 3px;
                    height: 18px;
                    background: #2448ff;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            span {
                font-size: 14px;
                color: #666;
            }
        }
        .list {
            .item {
                .ibox {
                    cursor: pointer;
                    padding: 30px;
                    background-size: 100% 100% !important;
                    border-radius: 8px;
                    overflow: hidden;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    height: 130px;
                    .img {
                        width: 56px;
                        height: 56px;
                        margin-right: 14px;
                        flex-shrink: 0;
                    }
                    .text {
                        p {
                            font-size: 22px;
                            color: #fff;
                            font-weight: 600;
                            margin-bottom: 8px;
                            line-height: 22px;
                        }
                        span {
                            font-size: 12px;
                            color: #fff;
                        }
                    }
                }
                .price {
                    margin: 14px;
                    cursor: pointer;
                    .isPay {
                        cursor: auto;
                    }
                    p {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        color: #ff8a00;
                        font-weight: 600;
                        i {
                            margin-left: 14px;
                            font-size: 24px;
                            color: #666;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
}
.oColor {
    color: #ff8a00 !important;
}
</style>